$(document).ready(function () {
  $('.continue-shopping').on('click', (e) => {
    if(!localStorage.getItem('previousProduct')) return;

    const previousProduct = localStorage.getItem('previousProduct');
    e.preventDefault();
    window.location = previousProduct;
  })
  $('#order-summary-checkout').on('click', function () {
    $('#cart #checkout').trigger('click');
  });
});
